
import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";
import AnchorLink from "react-anchor-link-smooth-scroll";
import linkdin from "../assets/linkedin.png"
import github from "../assets/github-mark-white.png"
import { Flex } from "@chakra-ui/react";

const Landing = ({ setSelectedPage }) => {
  const isAboveLarge = useMediaQuery("(min-width: 1060px)");
  return (
    <section
      id="home"
      className=" md:h-full py-10"
    >
<Flex direction={{base:"column", sm:"row"}} justify="space-between">
<div className="z-30 basis-3/5 mt-12 md:mt-32 ">
    
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <p className="text-6xl font-playfair  text-center md:text-start text-yellow">
        <p className="text-3xl text-blue" p={2}> Hello, I'm Akhilesh yadav</p> 
            
              Full Stack Web Developer
           
          </p>

        </motion.div>
        </div>
        <div className="z-30 basis-3/5 mt-12 md:mt-32 ">
        <motion.div
        className="flex mt-5 justify-center md:justify-start"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: 150 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <AnchorLink
          className="bg-gradient-rainblue text-deep-blue rounded-sm py-3 px-7 font-semibold
            hover:bg-blue hover:text-white transition duration-500"
          onClick={() => setSelectedPage("contact")}
          href="#contact"
        >
          Contact Me
        </AnchorLink>
        <AnchorLink
          className="rounded-r-sm bg-gradient-rainblue py-0.5 pr-0.5"
          onClick={() => setSelectedPage("contact")}
          href="#contact"
        >
          <div className="bg-deep-blue hover:text-red transition duration-500 w-full h-full flex items-center justify-center px-10 font-playfair">
            Let's talk.
          </div>
        </AnchorLink>
      </motion.div>

      <motion.div
        className="flex mt-5 justify-center md:justify-start"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
      <div className="flex  my-10 gap-10">
      <a
      className="hover:opacity-50 transition duration-500"
      href="https://www.linkedin.com"
      target="_blank"
      rel="noreferrer"
    >
      <img alt="linkedin-link" src={linkdin} />
    </a>
    <a
      className="hover:opacity-50 transition duration-500"
      href="https://github.com/Akhi4009"
      target="_blank"
      rel="noreferrer"
    >
      <img className=" w-9" alt="linkedin-link" src={github} />
    </a>
    </div>
      </motion.div>
    </div>
</Flex>
<div className="z-30 basis-3/5 mt-12 md:mt-32 ">
    
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          <p className="text-6xl font-playfair  text-center md:text-start text-red">
        <p className="text-3xl text-blue" p={2}> Welcome to</p> 
            
             My Creative Uinverse
           
          </p>

        </motion.div>
        </div>
   
    </section>
  );
};

export default Landing;
